/**
 * Don't use
 * TODO: remove and replace style guide ui-btns
 */
const UiBtn = class extends HTMLElement {
  static observedAttributes = [
    "disabled",
    "variant", // "icon-only" | "secondary" | "small" | "small-caps"
    "label",
    "aria-label",
    "icon-left",
    "icon-only",
    "type",
    "color", // "white" | "outline" | "outline-white"
  ];

  connectedCallback() {
    const href = this.getAttribute("href");
    const label = this.getAttribute("label");
    const ariaLabel = this.getAttribute("aria-label");
    const disabled = !!this.getAttribute("disabled");
    const icon = this.getAttribute("icon");
    const variant = this.getAttribute("variant");
    const color = this.getAttribute("color");
    const type = this.getAttribute("type");

    const classes = `button ${
      variant === "icon-only"
        ? "icon-only"
        : variant === "secondary" && color === "outline-white"
        ? "button--secondary button--outline-white"
        : variant === "secondary"
        ? "button--secondary"
        : variant === "small"
        ? "button--small"
        : variant === "small-caps"
        ? "button--small button--small-caps"
        : ""
    } ${color ? `button--${color}` : ""}`;

    const element = href ? "a" : "button";
    const isSmall = variant === "small" || variant === "small-caps";
    const outerClass = isSmall ? "button-small-wrap" : classes;

    this.innerHTML = /*html*/ `<${element} ${href ? `href="${href}"` : ""} class="${outerClass}" ${
      !href ? `aria-label="${ariaLabel}"` : ``
    } ${disabled ? "disabled" : ""} ${type ? `type="${type}"` : ""}>
      ${isSmall ? `<span class="${classes}">` : ""}
      ${
        icon
          ? /*html*/ `<svg class="icon ${variant !== "icon-only" ? "icon-left" : ""}">
          <use xlink:href="#${icon}"></use>
        </svg>`
          : ""
      }
      ${variant === "icon-only" ? "" : label}
      ${isSmall ? `</span>` : ""}
    </${element}>`;
  }
};

customElements.define("ui-btn", UiBtn);
